import React from 'react'
import { KibCheckOutlineIcon } from '@chewy/kib-icons-react'

import styles from './PaymentSuccessScreenTitle.module.scss'

interface PaymentSuccessScreenTitleProps {
  title: string
}

export const PaymentSuccessScreenTitle = ({
  title,
}: PaymentSuccessScreenTitleProps) => (
  <div className={styles.paymentSuccessTitleContainer}>
    <KibCheckOutlineIcon className={styles.paymentSuccessIcon} />
    {title}
  </div>
)
